import { readState } from "@/__main__/app-state.mjs";
import { IS_DEV } from "@/__main__/constants.mjs";
import { setFeatureFlag } from "@/app/actions.mjs";
import { SEARCH_PARAMS } from "@/feature-news/constants.mjs";

const CMS_PERMISSIONS = {
  CMS_ACCESS: "5",
  // In the future, we can limit CMS access to certain sub-features
  // For now, this is irrelevant, but this is displayed here to further nuture development
  // if that happens to be a task to create a more granular permission system
  CMS_APEX: "15",
  CMS_VALORANT: "17",
  CMS_CS2: "18",
  CMS_EFT: "19",
};

export function hasCMSAccess(searchParams?: URLSearchParams): boolean {
  const isEnvStaging = !!(searchParams?.get(SEARCH_PARAMS.ENV) === "staging");
  const isArg = searchParams instanceof URLSearchParams ? isEnvStaging : true;
  const isUserAccess =
    IS_DEV ||
    !!readState.user?.roles?.some(
      ({ id }) => CMS_PERMISSIONS.CMS_ACCESS === id,
    );
  return isUserAccess && isArg;
}

export function setCMSFeature(): void {
  if (!hasCMSAccess()) return;
  setFeatureFlag("cms", true);
}
